var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconError = function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.771 3.002c.767-1.336 2.69-1.336 3.458 0l15.502 27c.766 1.333-.194 2.998-1.729 2.998H4.998c-1.535 0-2.495-1.665-1.729-2.999zm-.176 10.982a1.91 1.91 0 0 1 1.905-1.99c1.082 0 1.954.906 1.905 1.99l-.34 7.515a1.57 1.57 0 0 1-1.565 1.498c-.837 0-1.526-.66-1.564-1.498zM20.5 24.998a2 2 0 0 0-1.995 2c0 1.105.893 2 1.995 2a2 2 0 0 0 1.995-2c0-1.105-.893-2-1.995-2",
    clipRule: "evenodd"
  })));
};
export default SvgIconError;